<template>
    <section id="empreendimentos">
        <div class="container">
            <h1>EMPREENDIMENTOS</h1>
        </div>
        <div class="arrowreference">
            <div class="arrows">
                    <a href="javascript:void(0);" class="prev" @click="showPrev">
                        <arrowslideleft/>
                    </a>
                    <a href="javascript:void(0);" class="prox" @click="showNext">
                        <arrowslideright/>
                    </a>
            </div>
            <VueSlickCarousel  v-bind="settings" class="slick-empreendimento" ref="carousel">
                    <div v-for="empreendimento in empreendimentos" :key="empreendimento.id" class="item">
                        <!-- {{empreendimento.nome}} -->
                        <iframe  :src="empreendimento.video" frameborder="0" 
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                        allowfullscreen></iframe>
                        <div class="conteudos">
                            <div class="icone">
                                <img :src="empreendimento.logo" :alt="empreendimento.nome">
                            </div>
                            <div class="conteudo">
                                <h2>{{empreendimento.nome}}</h2> 
                                <h3>{{empreendimento.cidade}}</h3>
                                <p>
                                    {{empreendimento.texto}}
                                </p>
                                <a :href="empreendimento.hotsite" target="_blank">SAIBA MAIS</a>
                            </div>
                        </div>
                        
                    </div>
            </VueSlickCarousel>
            
        </div>


        <div class="top"></div>
        <div class="bottom"></div>
    </section>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import arrowslideleft from './icones/arrowslideleft'
import arrowslideright from './icones/arrowslideright'

export default {
    name: 'Empreendimentos',
    components: { VueSlickCarousel,arrowslideleft,arrowslideright },
    data(){
        return {
            empreendimentos:[
                {
                    id:1,
                    nome:'RESERVA BARLAVENTO',
                    cidade:'RIO GRANDE RS',
                    logo:'images/empreendimentos/MarcaBarlavento.png',
                    video:'https://www.youtube.com/embed/s9_MTzDqU9U',
                    texto:`Toda evolução começa com um olhar profundo para dentro de nós mesmos. 
                    O lugar para onde Rio Grande prospera está ancorado em quem somos e na nossa origem. 
                    Nossa essência genuína está nas formas e materiais utilizados no Reserva Barlavento.
                    Um condomínio horizontal de lotes que une conforto, natureza e modernidade numa proposta inédita na cidade.`,
                    hotsite:'https://reservabarlavento.com.br'
                }
            ],
            settings: {
                arrows: true,
                dots: false,
                autoplay:true,
                autoplaySpeed:10000,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                pauseOnHover: true,
                draggable:false,
                   
            },
        }
    },
    methods: {
      showNext() {
        this.$refs.carousel.next()
      },
      showPrev() {
        this.$refs.carousel.prev()
      },
    },
}
</script>
<style lang="scss" scoped>
    @import 'node_modules/bootstrap/scss/bootstrap';
    @import 'node_modules/bootstrap-vue/src/index.scss';
    @import "../../public/variables.scss";
        section{
            position: relative;
            width:100%;
            overflow: hidden;
            .top{
                position: absolute;
                top: 0;
                left: 0;
                height: 50%;
                width: 100%;
                background-color:$azul-marinho;
                z-index: -1;
            }
            .bottom{
                position: absolute;
                bottom: 0;
                left: 0;
                height: 50%;
                width: 100%;
                background-color: $cinza-claro;
                z-index: -1;

            }
            h1{
                font-family: 'Intro';
                font-size: 40px;
                color:white;
                position: relative;
                z-index: 1;
                margin-bottom: 100px;
                &::before{
                    display: block;
                    content: '';
                    position: absolute;
                    bottom: -20px;
                    left: 0;
                    width:50px;
                    height: 3px;
                    background-color: white;
                }
            }
            .arrowreference{
                max-width: 1600px;
                margin: 0 auto;
                .arrows{
                    display: none;
                    position:absolute;
                    bottom: 148px;
                    right: 10%;
                    z-index: 1;
                }
                .slick-empreendimento{
                    max-width: 100%;
                    
                    .item{
                        width: 100%;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        iframe{
                            width:70% ;
                            height:600px;
                            float:left;
                        }
                        .conteudos{
                            width:35% ;
                            height:600px;
                            float:left;
                            position: absolute;
                            right: 0;
                            .icone{
                                width: 100%;
                                height: 150px;
                                text-align: center;
                                img{
                                    margin: 0 auto;
                                }
                            }
                            .conteudo{
                                width: 100%;
                                height: 450px;
                                background-color: $cinza-claro;
                                padding:40px;
                                position: relative;
                                h2{
                                    font-size: 22px;
                                    color:$azul-marinho;
                                }
                                h3{
                                    font-size: 20px;
                                    color:$azul-marinho;
                                }
                                p{
                                    font-size: 18px;
                                    color:$font-gray;
                                }
                                a{
                                    position: absolute;
                                    bottom: 0;
                                    left: 40px;
                                    color: white;
                                    border: none;
                                    padding: 10px 20px;
                                    border-radius: 2px;
                                    transition: 0.3s ease all;
                                    background-color:$azul-claro;
                                    &:hover{
                                        background-color:$azul-escuro;
                                        text-decoration: none;
                                    }
                                }
                            }
                        }
                    }
                }
                
            }
        }
        @media(max-width:1500px){
            section{
                .arrowreference{
                    max-width: 1200px;
                    .arrows{
                        bottom: 96px;
                    }
                    .slick-empreendimento{
                        .item{
                            iframe{
                                height: 500px;
                            }
                            .conteudos{
                                height: 500px;
                                width: 40%;
                                .icone{
                                    height: 130px;
                                }
                                .conteudo{
                                    height: 370px;
                                }
                            }
                        }
                    }
                }
            }
        }
        @media(max-width:900px){
            section{
                .arrowreference{
                    .slick-empreendimento{
                        .item{
                            
                            iframe{
                                height: 400px;
                                width: 90%;
                                display: block;
                                margin: 0px 5%;;
                            }
                            .conteudos{
                                height: auto;
                                width: 100%;
                                position: inherit;
                                .icone{
                                    height: auto;
                                    padding:20px 0;
                                }
                                .conteudo{
                                    height: auto;
                                }
                            }
                        }
                    }
                }
                .top{
                    height: 80%;
                }
                .bottom{
                    height: 20%;
                }
            }
        }
        @media(max-width:600px){
        section{
            .arrowreference{
                .slick-empreendimento{
                    .item{
                        iframe{
                            height: 210px;
                        }
                    }

                }
            }
            
            h1{
                font-size: 36px;
            }
        }
    }
</style>